import React, { FC } from 'react'

import * as SC from './styled'

export type BoxedContentProps = {
  className?: string
  children?: React.ReactNode
}

const BoxedContent: FC<BoxedContentProps> = (props) => {
  const { className, children = null } = props

  return <SC.BoxedContent className={className}>{children}</SC.BoxedContent>
}

export default BoxedContent
